<template>
  <Modal
    :value="isShow"
    width="900"
    class="cooModalBox"
    @on-cancel="cancelHandle"
    :mask-closable="false"    
    class-name="vertical-center-modal"
  >
    <span slot="header" style="font-size: 16px;color:#333;"
      >{{
        dataSet && dataSet.materialPN ? (isEdit ? "编辑" : "查看") : "新增"
      }}原材料
    </span>
    <div class="modal-content">
      <div class="modal-content-wrap">
      <div v-if="form.materialType=='i-material'">请录入单位产品所使用的间接材料价值</div>
        <div class="coo">
          <Form
            ref="form"
            :model="form"
            :rules="rulesForm"
            @submit.native.prevent
          >
            <table style="width: 100%; margin-top: 8px;">
              <tbody>
                <tr>
                  <td class="td-title1 td-title-align">
                    <label class="control-label "> &nbsp;原料属性 </label>
                  </td>
                  <td class="td-content1">
                    <FormItem prop="materialType" class="bitian">
                      <Select v-model="form.materialType" :disabled="!isEdit">
                        <Option
                          v-for="(k, v) in $options.filters.getMaterialType(
                            '',
                            true
                          )"
                          :value="v"
                          :key="v"
                          >{{ k }}</Option
                        >
                      </Select>
                    </FormItem>
                  </td>
                  <td class="td-title1 td-title-align">
                    <label class="control-label "> &nbsp;原料料号 </label>
                  </td>
                  <td class="td-content1 ">
                    <FormItem>
                      <Input
                        v-model.trim="form.materialPN"
                        :disabled="!isEdit"
                        :clearable="isEdit"
                        placeholder="请填写原材料料号"
                      ></Input>
                    </FormItem>
                  </td>
                </tr>
                <tr>
                  <td class="td-title1 td-title-align">
                    <label class="control-label ">
                      &nbsp;原辅料/零部件名称
                    </label>
                  </td>
                  <td class="td-content1">
                    <FormItem>
                      <Input
                        v-model.trim="form.materialName"
                        :disabled="!isEdit"
                        :clearable="isEdit"
                        placeholder="请填写原辅料/零部件名称"
                      ></Input>
                    </FormItem>
                  </td>

                  <td class="td-title1 td-title-align">
                    <label class="control-label ">原料HS编码</label>
                  </td>
                  <td class="td-content1">
                    <FormItem prop="materialCode" class="bitian">
                      <Input
                        v-model.trim="form.materialCode"
                        :disabled="!isEdit"
                        :clearable="isEdit"
                        placeholder="请填写原材料商品编码"
                      ></Input>
                    </FormItem>
                  </td>
                </tr>
                <tr>
                  <td class="td-title1 td-title-align">
                    <label class="control-label ">原产地  </label>
                  </td>

                  <td class="td-content1">
                    <FormItem prop="materialOrigin" class="bitian">

                      <Export
                      v-model="form.materialOrigin"
                      class="ex"
                      :width="'200%'"
                      styleName="n"
                    ></Export>
                    
                    </FormItem>
                  </td>
                  <td class="td-title1 td-title-align">
                    <label class="control-label ">原料重量单位 </label>
                  </td>
                  <td class="td-content1" style="width: 12% !important">
                    <FormItem>
                      <Select
                        v-model="form.weightUnit"
                        disabled
                        :clearable="isEdit"
                        transfer
                        :placeholder="isEdit ? '请选择' : '-'"
                        class="tgroup_item2"
                      >
                        <Option
                          v-for="item in weightUnitArr"
                          :value="item.value"
                          :key="item.value"
                          >{{ item.name }}</Option>
                      </Select>
                    </FormItem>
                  </td>
                </tr>

                <tr>
                  <td class="td-title1 td-title-align">
                    <label class="control-label ">原材料单价 </label>
                  </td>

                  <td class="td-content1" style="width: 12% !important">
                    <FormItem prop="materialPrice" class="bitian">
                  

                      <InputNumber
                  
                      v-input-limit='3'  
                        v-model.trim="form.materialPrice"
                        :disabled="!isEdit"
                        :clearable="isEdit"
                        :min="0.001"
                        placeholder="请填写原材料单价"
                      ></InputNumber>
                    </FormItem>
                  </td>
                  <td class="td-title1 td-title-align">
                    <label class="control-label ">原料重量 </label>
                  </td>
                  <td class="td-content1" style="width: 12% !important">
                    <FormItem>
                      <InputNumber
                  
                      v-input-limit='3' 
                        v-model.trim="form.materialWeight"
                        :disabled="!isEdit"
                        :clearable="isEdit"
                        :min="0.001"
                        :placeholder="isEdit ? '请填写原材料重量' : '-'"
                      ></InputNumber>
                    </FormItem>
                  </td>
                </tr>

                <tr>
                  <td class="td-title1 td-title-align">
                    <label class="control-label ">货币币制 </label>
                  </td>
                  <td class="td-content1" style="width: 12% !important">
                    <FormItem>
                      <!-- <Input v-model.trim="form.materialPrice" :disabled="!isEdit" :clearable="isEdit" number placeholder="请填写原材料单价"></Input> -->

                      <Select
                        v-model="form.materialUnit"
                        disabled
                        :clearable="isEdit"
                        transfer
                        class="tgroup_item2"
                      >
                        <Option
                          v-for="item in ['CNY', 'USD']"
                          :value="item"
                          :key="item"
                          >{{ item }}</Option
                        >
                      </Select>
                    </FormItem>
                  </td>

                  <td class="td-title1 td-title-align">
                    <label class="control-label ">备注 </label>
                  </td>
                  <td class="td-content1" style="width: 12% !important">
                    <FormItem>
                      <Input
                        v-model.trim="form.materialDescription"
                        :disabled="!isEdit"
                        :clearable="isEdit"
                        :placeholder="isEdit ? '请填写原材料备注' : '-'"
                      ></Input>
                    </FormItem>
                  </td>
                </tr>
              </tbody>
            </table>
          </Form>
        </div>
        <div class="footer" style="margin-top: 20px;">
          <div class="footer-wrap clearfix">
            <Button type="primary" @click.prevent="okHandle" v-if="isEdit" style="font-size: 16px;"
              >确定</Button
            >
            <Button
              type="primary" style="font-size: 16px;"
              @click.prevent="$emit('changeState', false)"
              v-else
              >确定</Button
            >
          </div>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>

import Export from "@/components/common/Export3";
export default {

  name: "CooModalZH",
  components: {
    Export
  },
  props: {
    materialOriginArr: {
      type: Array,
      default: () => [],
      required: false
    },
    isShow: {
      type: Boolean,
      default: false,
      required: false
    },
    isEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    dataSet: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    }
  },
  created(){
    
   
  },
  
  data() {
    const validatePrice = (rule, value, callback) => {
      value = this._.trim(`${value}`);
      if (
        !value ||
      
        value <= 0 ||
        !this.form.materialUnit ||
        !this.$options.filters.isPrice(`${value}`)
      ) {
        callback(new Error("请正确填写原材料单价/单位"));
      } else {
        callback();
      }
    };
    const validWeight = (rule, value, callback) => {
      if (value) {
        value = parseFloat(this._.trim(`${value}`));
        if (this._.isNaN(value) || value <= 0 || !this.form.weightUnit) {
          callback(new Error("请正确填写原材料重量/单位"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validmaterialCode = (rule, value, callback) => {

     
        value = this._.trim(`${value}`);
        if (!value || value.length<6) {
          callback(new Error("请填写不少于6位得商品编码"));
        } else {
          callback();
        }
     
    };
    return {
    
      isSubmit: false,
      weightUnitArr: [{name:'吨',value:'t'},{name:'千克',value:'kg'}, {name:'克',value:'g'}, {name:'毫克',value:'mg'}, {name:'微克',value:'ug'}, {name:'磅',value:'b'}, {name:'盎',value:'oz'}],
      form: {
        materialPN: "",
        materialType: "",
        materialName: "",
        materialCode: "",
        materialPrice: null,
        materialUnit: "CNY",
        materialOrigin: "",
        materialWeight: null,
        weightUnit: "kg",
        materialDescription: ""
      },
      rulesForm: {
        materialPN: [
          { required: true, message: "请填写原材料料号", trigger: "change" }
        ],
        materialName: [
          { required: true, message: "请填写原材料名称", trigger: "change" }
        ],
        materialType: [
          { required: true, message: "请填写原材料属性", trigger: "change" }
        ],
        materialCode: [
          { required: true, validator: validmaterialCode,  trigger: "change" }
        ],
        materialPrice: [
          {
            required: true,
            type: "number",
            message: "请填写原材料单价/单位",
            trigger: "change"
          },
          { validator: validatePrice, trigger: "change" }
        ],
        // materialUnit: [{ required: true, message: '请填写原材料单位', trigger: 'blur' }],
        materialOrigin: [
          { required: true, message: "请填写原材料原产地", trigger: "change" }
        ],
        materialWeight: [{ validator: validWeight, trigger: "change" }]
        // materialWeight: [{ required: true, message: '请填写原材料重量', trigger: 'blur' }],
      }
    };
  },
  watch: {
    "form.materialType"(newVal, oldVal) {
      if (newVal) {
        if (newVal == "t-packaging") {
          this.form.materialCode = "99999990";
        } else if (newVal == "p-packaging") {
          this.form.materialCode = "99999991";
        } else if (newVal == "a-record") {
          this.form.materialCode = "99999992";
        } else if (newVal == "i-material") {
          this.form.materialCode = "99999993";
        } else if (newVal == "e-cost") {
          this.form.materialCode = "99999994";
        } else if (newVal == "e-profit") {
          this.form.materialCode = "99999995";
        } 
        
        else {
          this.form.materialCode = "";
        }
      }
    },
    isShow(newVal, oldVal) {
      if (newVal) {
      
        if (this.dataSet.id || this.dataSet._id) {
          _.forEach(this.form, (value, key) => {
            if (key == "materialWeight") {
              let [weight, weightUnit] = this.splitWeightUnit(
                this.dataSet[key] || ""
              );
              this.form[key] = weight;
          
            } else if (key != "materialWeight") {
              this.form[key] = this.dataSet[key];
              this.form = {
                materialUnit: "CNY",
                weightUnit: "kg",
                ...this.form
              }
            }
          });
       
          setTimeout(() => {
            this.form.materialCode = this.dataSet.materialCode;
          }, 500);
        }
       
        
        else {
          this.form = {
            materialPN: "",
            materialType: "",
            materialName: "",
            materialCode: "",
            materialPrice: null,
            materialUnit: "CNY",
            materialOrigin: "",
            materialWeight: null,
            weightUnit: "kg",
            materialDescription: "",
            ...this.dataSet
          };
        }
      }
    }
  },
  methods: {
  

    splitWeightUnit(val) {
      if (this._.trim(val)) {
        let reg = /[a-zA-Z]+?$/;
        if (reg.test(val)) {
          let tmp = val.match(reg)[0],
            tmp2 = val.replace(tmp, "");
       
   
         
          tmp = this.weightUnitArr.findIndex(item=>item.value==tmp)!= -1 ? tmp : "";
          return [parseFloat(tmp2) || null, tmp];
        }
      }
      return [null, ""];
    },
    okHandle(event) {
      if (!this.isSubmit) {
        this.$refs["form"].validate(valid => {
          if (valid) {
            let _formData = this._.assign({}, this.form);
            _formData["materialWeight"] = _formData["materialWeight"]
              ? _formData["materialWeight"] + _formData["weightUnit"]
              : "";

            _formData = _.omit(_formData, ["weightUnit"]);
       

            this.$parent.addMaterial(_formData, this.dataSet._id);
            this.cancelHandle();
          }
        });
      }
    },
    cancelHandle() {
      this.$emit("changeState", false);
      this.$refs["form"] && this.$refs["form"].resetFields();
    }
  }
};
</script>
<style>
@media print, screen and (min-width: 1366px) {
  .cooModalBox .vertical-center-modal,
  .cooModalBox .ivu-modal {
    width: 900px !important;
    margin: 0 auto;
  }
  .cooModalBox .ivu-modal-close .ivu-icon-ios-close-empty {
    top: 0 !important;
  }
}
@media print, screen and (max-width: 1365px) {
  .cooModalBox .vertical-center-modal,
  .cooModalBox .ivu-modal {
    width: 900px !important;
    margin: 0 auto;
  }
}
.bitian input {
  background: #faffbd !important;
}
.bitian .ivu-select-selection {
  background: #faffbd !important;
}
.cooModalBox .vertical-center-modal {
  /* display: flex;
    align-items: center;
    justify-content: center; */
  margin: 0 auto;
  /* margin-top: -100px; */
  overflow: hidden;
}
.cooModalBox .vertical-center-modal .ivu-modal {
  top: 50%;
  transform: translateY(-50%);
}
.cooModalBox .ivu-modal-header {
  font-weight: bold;
  font-size: 16px !important;
}
/*.cooModalBox .ivu-modal-header,*/
.cooModalBox .ivu-modal-footer {
  display: none;
}
/*.cooModalBox .ivu-modal-close{*/
/*display: none;*/
/*}*/
.cooModalBox .modal-content-wrap .title {
  text-align: center;
  font-size: 16px !important;
  color: #666;
  margin: 5px 0 16px;
}
.ivu-select-placeholder {
  text-align: left;
}
.ivu-select-selected-value {
  text-align: left;
}
input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #bbbec4;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bbbec4;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bbbec4;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #bbbec4;
}
input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #bbbec4;
}
.cooModalBox .ivu-form-item-content {
  font-size: 16px !important;
}
.cooModalBox .ivu-input,
.cooModalBox .ivu-select-item,
.cooModalBox .ivu-select-placeholder,
.cooModalBox .ivu-select-selected-value,
.cooModalBox .ivu-input-number-input {
  font-size: 16px !important;
}
.cooModalBox .guide img {
  width: 100%;
}
/* .cooModalBox .ivu-carousel-item img{
    width: 893px;
    height: 435px;
  } */
.cooModalBox .footer {
  margin: 0px 0 15px;
}
.cooModalBox .footer .footer-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cooModalBox .footer .btn {
  /* background-image: linear-gradient(-90deg, #0F7EF3 0%, #27BEFE 100%); */
  background-color: #0774b5;
  border-radius: 3px;
  font-size: 16px !important;
  color: #fff;
  height: 32px;
  line-height: 32px;
  width: 130px;
  text-align: center;
  float: left;
  cursor: pointer;
}
.cooModalBox .footer .ivu-checkbox-wrapper {
  font-size: 16px;
  color: #999;
  padding-left: 15px;
}
.cooModalBox .ivu-input-wrapper .ivu-input-icon {
  line-height: 32px !important;
  width: 32px;
  height: 32px;
}
</style>
<style scoped>
.form-control,
.single-line {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #e5e6e7;
  /* border-radius: 1px; */
  color: inherit;
  display: block;
  padding: 6px 16px;
  -webkit-transition: border-color 0.15s ease-in-out 0s,
    box-shadow 0.15s ease-in-out 0s;
  /* transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s; */
  width: 100%;
  font-size: 16px !important;
}
table input {
  border: 0px !important;
  font-size: 13px;
  outline: none;
}
input:focus {
  outline: 1px solid #123456;
}
.actions >>> .ivu-btn {
  border-radius: 2px;
  width: 130px;
  font-size: 16px !important;
}
td,
th {
  padding: 0;
}
table,
td,
th {
  border: 1px solid #ccc;
  font-size: 16px !important;
  height: 22px;
  max-height: 22px;
}
table {
  border-collapse: collapse;
}
.non-empty {
  background: #faffbd;
}
.form-control {
  padding: 0px 1px;
  border-radius: 1px;
}
table {
  background-color: transparent;
}

.form-control,
.single-line {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #e5e6e7;
  /* border-radius: 1px; */
  color: inherit;
  display: block;
  padding: 6px 6px;

  /* transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s; */
  width: 100%;
  font-size: 16px !important;
}
.material_list {
  position: relative;
}
.table-containter {
  position: relative;
  /* overflow-x: auto;
    overflow-y: hidden; */
  padding-bottom: 3px;
}
.table-wrap {
  width: 100%;
  border: 1px solid #eaf7ff;
}

.table-wrap >>> .ivu-table-wrapper {
  /* width: 1500px; */
}
.table-wrap >>> .ivu-table-body tr:nth-child(even) td {
  background-color: #eaf7ff;
}
.table-wrap >>> .ivu-table:before,
.table-wrap >>> .ivu-table:after {
  background-color: #eaf7ff;
}
.material_list >>> .ivu-table-wrapper {
  border: 0 none;
  /* box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50); */
}
.material_list >>> .ivu-table {
  color: #686765;
}
.material_list >>> .ivu-table th {
  background-color: #eaf7ff;
  font-size: 16px !important;
  font-weight: normal;
  border-color: #eaf7ff;
}
.material_list >>> .ivu-table th .ivu-table-cell {
  white-space: nowrap;
  font-size: 16px !important;
}
.material_list >>> .ivu-table td {
  font-size: 16px !important;
  border-width: 0;
}
.material_list >>> .ivu-table .ivu-checkbox-wrapper {
  margin-right: 0;
}
.material_list >>> .ivu-table .tb_select .ivu-table-cell {
  padding-right: 0;
}
.material_list >>> .ivu-table .tb_company .ivu-table-cell {
  padding-left: 0;
}
table >>> .ivu-input-number,
table >>> .ivu-select-selection {
  width: 100%;
  border: 0px solid #dddee1;
  border-radius: 0px;
  font-size: 16px !important;
}
table >>> .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-size: 16px !important;
}
table >>> .ivu-input {
  font-size: 16px !important;
  border: 0px solid #dddee1 !important;
  border-radius: 0px !important;
}
.material_list >>> .ivu-table .opr a.line2:after {
  /*text-decoration: underline;*/
  bottom: 0;
}
.ivu-form-item {
  margin-bottom: 0;
}
.td-title1 {
  width: 7%;
  text-align: right;
  padding-right: 5px;
}
</style>

<style scoped>
.tgroup_wrap {
  position: relative;
  padding-right: 73px;
}
.tgroup_wrap .tgroup_item2 {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 70px;
  margin-top: 0.5px;
}
.modal-content-wrap >>> .ivu-form-item-error-tip {
  right: 0;
  left: inherit;
  top: 10px;
  padding-top: 0;
  font-size: 16px;
}
.tgroup_wrap .ivu-input-number {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/cooModal.vue